import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './MapLayersPanel.module.css';
import Statistics from '../../containers/Statistics/Statistics';
import Legend from '../../containers/Legend/Legend';
// import * as actions from '../../store/actions/index';

class MapLayersPanel extends Component {

    state={
        panelClosed:false,
        activeTab:1
    }

    togglePanel = () => {
        this.setState({panelClosed:!this.state.panelClosed});
    }

    changeActiveTab(tab){
        this.setState({activeTab:tab});
    }

    render(){
        let mapLayersPanelClasses = [classes.MapLayersPanel];

        if (this.state.panelClosed){
            mapLayersPanelClasses.push(classes.Closed);
        }

        if (this.props.hideToolbars){
            mapLayersPanelClasses.push(classes.HideToolbars);
        }

        return (
            <div className={mapLayersPanelClasses.join(' ')}>            
                <div className={classes.MapLayersTitleRow}>
                    <div className={this.state.activeTab === 1 ? [classes.PanelButtonWrapper, classes.Active].join(' ') : classes.PanelButtonWrapper} onClick={() => this.changeActiveTab(1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"></path></svg>
                        <span>Επίπεδα</span>
                    </div>
                    <div className={this.state.activeTab === 2 ? [classes.PanelButtonWrapper, classes.Active].join(' ') : classes.PanelButtonWrapper} onClick={() => this.changeActiveTab(2)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path></svg>
                        <span>Στατιστικά</span>
                    </div>
                    <div className={classes.PanelArrowWrapper}>
                        <svg onClick={this.togglePanel} className={classes.CloseButton} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path d="M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"></path></svg>
                    </div>
                </div>
                <div className={classes.MapLayersContent}>

                    {this.state.activeTab === 1 ? <Legend legendItems={this.props.legendItems}/> : <Statistics/>}

                </div>
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        // basemapLayers:state.webgis.basemapLayers,
        // selectedBasemap:state.webgis.selectedBasemap
    };
}

const mapDispatchToProps = dispatch => {
    return {
        // onChangeBackground: (index) => dispatch(actions.changeBackground(index)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapLayersPanel);